'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _reactIcofont = require('react-icofont');

var _reactIcofont2 = _interopRequireDefault(_reactIcofont);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Api = require('../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _DeleteAddressModal = require('./DeleteAddressModal');

var _DeleteAddressModal2 = _interopRequireDefault(_DeleteAddressModal);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaymentCard = function (_React$Component) {
    _inherits(PaymentCard, _React$Component);

    function PaymentCard(props, context) {
        _classCallCheck(this, PaymentCard);

        var _this = _possibleConstructorReturn(this, (PaymentCard.__proto__ || Object.getPrototypeOf(PaymentCard)).call(this, props, context));

        _this.populatePaymentMethods = function (paymentMethods) {

            var self = _this;

            //show spinner
            Utils.showSpinner();

            if (Utils.isEmpty(self.state.customerId)) {
                self.setState({
                    initialMessage: "You have not saved any cards for transaction."
                }, function () {
                    self.props.callBackParent(false);
                    Utils.hideSpinner();
                });

                return;
            }

            if (paymentMethods == null || paymentMethods.length == 0) {
                var userDetailPtrId = _parse2.default.User.current().id;
                var sessionToken = _parse2.default.User.current().getSessionToken();
                var router = _this.props.history;
                var locId = _this.props.locId;

                var currentUser = _parse2.default.User.current();
                var paymentObject = {
                    "customerId": currentUser.get("cus_id")
                };

                _Api2.default.getSavedCards(userDetailPtrId, sessionToken, paymentObject).then(function (res) {
                    if (res.data) {
                        var results = res.data;
                        var defaultPaymentMethodIdx = results.findIndex(function (paymentMethod) {
                            return paymentMethod.default;
                        });

                        var defaultIdx = defaultPaymentMethodIdx == -1 ? '0' : defaultPaymentMethodIdx;

                        var initialMessage = "";
                        if (results.length === 0) {
                            initialMessage = "You have not saved any cards for transaction.";
                        }

                        self.setState({
                            paymentMethods: results,
                            selectedPaymentMethod: defaultIdx,
                            initialMessage: initialMessage
                        }, function () {
                            self.props.callBackParent(false);
                        });
                    }
                }, function (error) {
                    // check the error and alert the invalid session token
                    Utils.checkErrorIsInvalidSessionToken(error, router, locId, false);
                    _this.props.handleHideModal();
                    self.props.callBackParent(false);

                    self.setState({
                        initialMessage: "You have not saved any cards for transaction."
                    });
                });
            } else {
                var defaultPaymentMethodIdx = paymentMethods.findIndex(function (paymentMethod) {
                    return paymentMethod.default;
                });
                var defaultIdx = defaultPaymentMethodIdx == -1 ? '0' : defaultPaymentMethodIdx;

                var initialMessage = "";
                if (paymentMethods.length === 0) {
                    initialMessage = "You have not saved any cards for transaction.";
                }

                self.setState({
                    paymentMethods: paymentMethods,
                    selectedPaymentMethod: defaultIdx,
                    initialMessage: initialMessage
                });
            }
        };

        _this.hideDeleteModal = function () {
            return _this.setState({ showDeleteModal: false });
        };

        _this.state = {
            showDeleteModal: false,
            customerId: '',
            paymentMethods: [],
            index: 0
        };

        _this.deletePaymentMethod = _this.deletePaymentMethod.bind(_this);
        _this.hideDeleteModal = _this.hideDeleteModal.bind(_this);
        return _this;
    }

    _createClass(PaymentCard, [{
        key: 'componentDidMount',
        value: function componentDidMount() {

            var self = this;
            var router = this.props.history;
            var locId = this.props.locId;

            if (Utils.isEmpty(self.state.customerId)) {
                _parse2.default.User.current().fetch().then(function (user) {
                    self.setState({
                        customerId: user.get("cus_id")
                    }, function () {
                        self.populatePaymentMethods(null);
                    });
                }, function (error) {

                    // check the error and alert the invalid session token
                    Utils.checkErrorIsInvalidSessionToken(error, router, locId, false);
                    // console.log(`Error: ${error}`);
                    // console.log("Error occured while fetching latest user data!");
                });
            } else {
                self.populatePaymentMethods(null);
            }
        }
    }, {
        key: 'deletePaymentMethod',
        value: function deletePaymentMethod() {

            var self = this;
            var index = this.state.index;
            var toDelete = this.state.paymentMethods[index];
            var paymentMethodId = toDelete.paymentMethodId;
            var customerId = this.state.customerId;
            var router = this.props.history;
            var locId = this.props.locId;

            var userDetailPtrId = _parse2.default.User.current().id;
            var sessionToken = _parse2.default.User.current().getSessionToken();

            //show spinner
            Utils.showSpinner();

            var paymentObject = {
                "paymentMethodId": paymentMethodId
            };

            _Api2.default.detachPaymentMethod(userDetailPtrId, sessionToken, paymentObject).then(function (res) {
                if (res.data) {
                    var removedCard = self.state.paymentMethods.splice(index, 1);
                    var initialMessage = "";

                    if (self.state.paymentMethods.length === 0) {
                        initialMessage = "You have not saved any cards for transaction.";
                    }

                    self.setState({
                        paymentMethods: self.state.paymentMethods,
                        initialMessage: initialMessage
                    }, function () {
                        _Actions2.default.detachPaymentMethod(removedCard[0].paymentMethodId);
                        //hide bootstrap modal
                        $('#deleteModal').modal('hide');
                        self.hideDeleteModal();
                        self.props.callBackParent(false);
                    });
                }
            }, function (error) {
                // check the error and alert the invalid session token
                Utils.checkErrorIsInvalidSessionToken(error, router, locId, false);
                //hide bootstrap modal
                $('#deleteModal').modal('hide');
                self.hideDeleteModal();
                self.props.callBackParent(false);
                // console.log(error);
            });
        }
    }, {
        key: 'onClick',
        value: function onClick(idx) {
            this.setState({
                showDeleteModal: true,
                index: idx
            });
        }
    }, {
        key: 'renderSavedPaymentMethods',
        value: function renderSavedPaymentMethods() {
            var _this2 = this;

            var paymentMethod = this.state.paymentMethods;

            return paymentMethod.map(function (paymentMethod, index) {
                return _react2.default.createElement(
                    'div',
                    { className: "col-md-6", key: "pay" + index },
                    _react2.default.createElement(
                        'div',
                        { className: 'bg-white payments-item mb-4 shadow-sm card' },
                        _react2.default.createElement(
                            'div',
                            { className: 'gold-members p-4' },
                            _react2.default.createElement(
                                'div',
                                { className: "media" },
                                _react2.default.createElement(
                                    'div',
                                    { className: "media-body" },
                                    _react2.default.createElement(
                                        'h6',
                                        { className: 'mb-2' },
                                        paymentMethod.maskedNumber
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'mb-0 text-black font-weight-bold' },
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { className: 'text-danger', to: '#', tabIndex: 12, onClick: _this2.onClick.bind(_this2, index) },
                                            _react2.default.createElement(_reactIcofont2.default, { icon: 'ui-delete' }),
                                            ' DELETE'
                                        )
                                    )
                                )
                            )
                        )
                    )
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var paymentMethod = this.state.paymentMethods;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                this.state.showDeleteModal ? _react2.default.createElement(_DeleteAddressModal2.default, {
                    onHide: this.hideDeleteModal,
                    callBackParent: this.deletePaymentMethod
                }) : null,
                paymentMethod.length === 0 && !Utils.isEmpty(this.state.initialMessage) ? _react2.default.createElement(
                    'div',
                    { className: "col-md-6" },
                    _react2.default.createElement(
                        'div',
                        { className: 'bg-white payments-item mb-4 shadow-sm card' },
                        _react2.default.createElement(
                            'div',
                            { className: 'gold-members p-4' },
                            _react2.default.createElement(
                                'div',
                                { className: "media" },
                                _react2.default.createElement(
                                    'div',
                                    { className: "media-body" },
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'mb-0 text-primary font-weight-bold text-primary' },
                                        this.state.initialMessage
                                    )
                                )
                            )
                        )
                    )
                ) : this.renderSavedPaymentMethods()
            );
        }
    }]);

    return PaymentCard;
}(_react2.default.Component);

exports.default = PaymentCard;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/PaymentCard.jsx
// module id = 554
// module chunks = 0